// extracted by mini-css-extract-plugin
module.exports = {"filter-group":"filter-group--3XCPH","icon":"icon--k1jlH"};